import { useEffect } from 'react'

import { useAppDispatch } from '../common/hooks'
import { setIsDarkTheme } from '../features/dashboard'

// Listen to messages from the parent window
export const useListenFrameParentMessage = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    window.addEventListener('message', event => {
      if (event.data.type === 'data-update') {
        dispatch(setIsDarkTheme({ isDarkTheme: event.data.isDarkTheme }))
      }
    })
  }, [])
}
